import * as types from './types'

export const showPasswordModal = () => ({
  type: types.SHOW_PASSWORD_MODAL,
})

export const closePasswordModal = () => ({
  type: types.CLOSE_PASSWORD_MODAL,
})

export const showValidationMessage = (success, message) => ({
  type: types.VALIDATION_MESSAGE,
  success,
  message,
})

export const updateAPIActionFeedback = (message) => ({
  type: types.SET_API_ACTION_FEEDBACK,
  message,
})
